import BottomSheet from '@gorhom/bottom-sheet';
import { useNavigation } from '@react-navigation/native';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BottomSheetFilterProps, BottomSheetFilterValues } from '@/features/account-management/screens/list/BottomSheetFilter';

export const useListNative = ({ currencies }: { currencies: { label: string; value: string }[] }) => {
  const navigation = useNavigation();
  const bottomSheetRef = useRef<BottomSheet>(null);
  const { t } = useTranslation('account-management');

  const onClose = () => {
    navigation.goBack();
  };

  const [filter, setFilter] = useState<BottomSheetFilterValues>({});
  const filterNumbers = Object.keys(filter)
    .map((key) => filter[key])
    .filter((item) => item).length;

  const bottomSheetFilterProps: BottomSheetFilterProps = {
    title: t('earn-invest::glossary.mobile-filter'),
    bottomSheetRef,
    options: [
      {
        label: t('card-account-management::glossary.mobile-filter--text-currency'),
        name: 'currency',
        options: currencies,
        singleSelect: true
      }
    ],
    values: filter,
    filteringNumber: filterNumbers,
    onClose,
    onChange: (tempFilters) => {
      setFilter(tempFilters);
    }
  };

  return {
    bottomSheetRef,
    filter,
    bottomSheetFilterProps
  };
};
